import React, { useRef } from "react";
import "./style.css";

/**
 * @param {{
 * 	logo: string | null,
 * 	onLogoChange: (logo: string | null) => void
 * }} props
 */
export default function LogoUpload({ logo, onLogoChange }) {
	const inputRef = useRef(null);

	const handleFileChange = (e) => {
		const file = e.target.files && e.target.files[0];
		if (!file) return;

		const reader = new FileReader();
		reader.onload = (event) => {
			const result = event && event.target ? event.target.result : null;
			onLogoChange(typeof result === "string" ? result : null);
		};
		reader.readAsDataURL(file);
	};

	const handleRemove = (e) => {
		e.stopPropagation();
		onLogoChange(null);

		if (inputRef.current) {
			inputRef.current.value = "";
		}
	};

	const openPicker = () => {
		if (inputRef.current) inputRef.current.click();
	};

	return (
		<div className="logo-upload-zone" onClick={openPicker} role="button" tabIndex={0}>
			{logo ? (
				<div className="logo-upload-inner">
					<img src={logo} alt="Company Logo" className="logo-image" />
					<button
						type="button"
						onClick={handleRemove}
						className="logo-remove"
						aria-label="Remove logo"
						title="Remove logo"
					>
						{/* X icon */}
						<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true">
							<path d="M18.3 5.7a1 1 0 0 0-1.4 0L12 10.6 7.1 5.7a1 1 0 1 0-1.4 1.4l4.9 4.9-4.9 4.9a1 1 0 1 0 1.4 1.4l4.9-4.9 4.9 4.9a1 1 0 0 0 1.4-1.4L13.4 12l4.9-4.9a1 1 0 0 0 0-1.4Z" />
						</svg>
					</button>
				</div>
			) : (
				<div className="logo-empty">
					<span className="logo-icon" aria-hidden="true">
						{/* Upload icon */}
						<svg viewBox="0 0 24 24" width="20" height="20">
							<path d="M12 3a1 1 0 0 1 .7.3l4 4a1 1 0 1 1-1.4 1.4L13 6.4V15a1 1 0 1 1-2 0V6.4L8.7 8.7A1 1 0 0 1 7.3 7.3l4-4A1 1 0 0 1 12 3Zm-7 14a1 1 0 0 1 1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 1 1 2 0v1a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-1a1 1 0 0 1 1-1Z" />
						</svg>
					</span>
					<span className="logo-text">Add Logo</span>
				</div>
			)}

			<input
				ref={inputRef}
				type="file"
				accept="image/*"
				onChange={handleFileChange}
				className="logo-file"
			/>
		</div>
	);
}
